<!-- 意向参考 -->
<template>
  <div class="choose-detail-content">
    <div>
      <div class="choose-detail-table">
        <Table :columns="columnsData"
               :data="univerList"
               :border=true></Table>
      </div>
      <div class="choose-detail-pageWrap"
           v-show="Math.ceil(totalItems/pageSize)>1">
        <Page :total="totalItems"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="handlePageChange"
              @on-page-size-change="handlePageSizeChange"></Page>
      </div>
    </div>
  </div>
</template>

<script>
// mixins
import mixinsPage from '@/view/mixins/page'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: '',
  components: {},
  props: ['tabColumns', 'hasFeedback'],
  mixins: [mixinsPage, isAllowEdit],
  data () {
    return {
      id: this.$route.query.id,
      pageSize: 50,
      univerList: [],
      columnsData: [
        {
          title: '-',
          key: 'name',
          align: 'center'
        },
        {
          title: '意向操作',
          key: 'college',
          align: 'center',
          width: 100,
          fixed: 'right',
          render: (h, params) => {
            let isIntention = params.row.purpose
            if (isIntention === 'YES') {
              return h('div', '--')
            }
            return h('div', {
              style: {
                color: '#6589dd',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  if (this.isallowedit) {
                    this.$emit('on-change-intention', {
                      id: params.row.id,
                      purpose: 'YES'
                    })
                  }else{
                    this.noPermission()
                  }
                }
              }
            }, '添加')
          }
        }
      ]
    }
  },
  mounted () {
    this.getPageList()
  },
  methods: {
    getPageList () {
      let data = {
        sourceId: this.id,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      this.$parent.getPageList(data).then(res => {
        this.univerList = res.data.page.result
        this.totalItems = res.data.page.totalItems
      }).catch(() => {
        this.univerList = []
        this.currentPage = 1
        this.totalItems = 0
      })
    }
  },
  watch: {
    tabColumns: {
      handler (newValue) {
        this.columnsData.splice(0, 0, ...newValue)
      },
      immediate: true
    },
    hasFeedback: {
      handler (newValue) {
        if (newValue) {
          this.columnsData.pop()
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
